module.exports = __webpack_public_path__ + "e3457e705151f8a0245a0a2ee470467f.svg";